export class Dictionary<T1,T2> {
  key: T1;
  id: T1;
  value: T2;
  name: T2;
}
